import styles from  '../styles/module/document.module.css';
 

const Impressum = () => {
    return (
        <div className={styles.impressumContainer}>
            <h2 className={styles.impressumTitle}>Impressum</h2>

            <h3 className={styles.sectionTitle}>KANDO</h3>
            <p>Tran Quoc Toan</p>
            <p>KANDO Restaurant</p>
            <p>Nikolaistr. 01</p>
            <p>04109 Leipzig</p>

            <h3 className={styles.sectionTitle}>Kontakt</h3>
            <div className={styles.contactInfo}>
                <p>Telefon: 034124837553</p>
                <p>E-Mail: info@zenchileipzig.de</p>
            </div>

            <h3 className={styles.sectionTitle}>Umsatzsteuer-ID</h3>
            <div className={styles.umStId}>
                <p>Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:</p>
                <p>DE360829414</p>
            </div>

            <h3 className={styles.sectionTitle}>Redaktionell verantwortlich</h3>
            <p>Tran Quoc Toan</p>

            <h3 className={styles.sectionTitle}>EU-Streitschlichtung</h3>
            <div className={styles.euStreitschlichtung}>
                <p>
                    Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
                    <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer">
                        https://ec.europa.eu/consumers/odr/
                    </a>.
                </p>
                <p>Unsere E-Mail-Adresse finden Sie oben im Impressum.</p>
            </div>

            <h3 className={styles.sectionTitle}>Verbraucher­streit­beilegung/Universal­schlichtungs­stelle</h3>
            <p className={styles.hinweis}>Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>
        </div>
    );
};
export default Impressum;